import { Api } from './mainApi'
import { Tenders } from './Tenders'
import { Problems } from './Problems'

export const mainApi = new Api()
export const problemApi = new Problems()
export const tendersApi = new Tenders()
